'use client';

import React from 'react';
import FiltersSection from './sections/FiltersSection';
import type { CollectionTerm, CollectionIntroduction, FilterSummary } from '@skin-seoul/service';
import type { TaxonomyCategory } from '../utils/categoryUtils';
interface CollectionPageContentProps {
  category?: string;
  subcategory?: string;
  subSubcategory?: string;
  brand?: string;
  productTag?: string;
  collectionTerm?: CollectionTerm;
  introduction?: CollectionIntroduction;
  hasIntroductionSection?: boolean;
  categories?: TaxonomyCategory[];
  productCount?: number;
  initialFilterSummary?: FilterSummary;
}
const CollectionPageContent = ({
  category,
  subcategory,
  subSubcategory,
  brand,
  productTag,
  collectionTerm,
  introduction,
  hasIntroductionSection,
  categories,
  productCount,
  initialFilterSummary
}: CollectionPageContentProps) => {
  return <FiltersSection category={category} subcategory={subcategory} subSubcategory={subSubcategory} brand={brand} productTag={productTag} introduction={introduction} collectionTerm={collectionTerm} hasIntroductionSection={hasIntroductionSection} categories={categories} productCount={productCount} initialFilterSummary={initialFilterSummary} data-sentry-element="FiltersSection" data-sentry-component="CollectionPageContent" data-sentry-source-file="CollectionPageContent.tsx" />;
};
export default CollectionPageContent;